import React from 'react';

import BasicStep from './BasicStep';
import PersonCoordinate from '../Forms/PersonCoordinate';
import AccountInformation from '../Forms/AccountInformation';
import Signature from '../Forms/Signature';


export default class BankAccountInformation extends BasicStep {
  constructor(props) {
    super(props);

    this.state = {
      bankAccount: props.getStore().bankAccount,
      pharmacy : props.getStore().pharmacy,
      validationErrors: { },
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  // not required as this component has no forms or user entry
  // isValidated() {}
  isValidated() {
    return new Promise((resolve, reject) => {
      const hasError = !this.checkForm();

      if (hasError) {
        reject(); // form contains errors
        return;
      }

      //if (this.props.getStore().emailEmergency != this.getValidatorData().emailEmergency) { // only update store of something changed
        this.props.updateStore({
          ...this.getValidatorData(),
          savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
        });  // Update store here (this is just an example, in reality you will do it via redux or flux)
      //}

      resolve(); // form is valid, fire action
    });
  }

  getValidatorData() {
    var object = {};

    object = this.props.getStore();
    object.bankAccount = this.state.bankAccount;
    object.signature = this.refs["signature"].getObject();

    return object;
  }

  /**
   * @return boolean false if there are some errors
   */
  checkForm() {
    let formsChecked = [];
    formsChecked[0] = this.refs["coordinate"].checkForm();
    formsChecked[1] = this.refs["bankCoord"].checkForm();
    formsChecked[2] = this.refs["accountInfo"].checkForm();
    formsChecked[3] = this.refs["signature"].checkForm();

    // If the form checked array contains a false value, so there is an error
    return !formsChecked.includes(false);
  }

  onError = (errors) => {
    this.setState({
      businessHoursErrors: errors,
    });
  }

  render() {
    return (
      <div>
        <form className="form">
          <div className="row">
            <div className="mycol-6">
              <h3 className="margin-bottom-xs text-center">Désignation du titulaire à débiter</h3>
              <PersonCoordinate ref="coordinate" useBankName={false}
                coordinate={this.state.bankAccount.coordinate}
                defaultCoordinate={this.state.pharmacy.coordinate}
              />
            </div>
            <div className="mycol-6">
              <h3 className="margin-bottom-xs text-center">Coordonnées de la banque</h3>
              <PersonCoordinate ref="bankCoord" useBankName={true}
                coordinate={this.state.bankAccount.bankCoordinate}
              />
            </div>
          </div>

          <AccountInformation 
            ref="accountInfo"
            account={this.state.bankAccount.account}
          />

          <div className="margin-bottom-s">
            Les factures émises seront réglées exclusivement par prélèvement à 30 jours nets date de facture.
            Elles seront envoyées à l’adresse de la pharmacie
          </div>

          <Signature ref="signature" />
        </form>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Steps/BankAccountInformation.js